/**
 * ============================================================
 * Email Signup Popup — JavaScript
 * ============================================================
 * Standalone. No modifications to postal-code-gate required.
 *
 * Trigger modes:
 *  - "after_postal_code" → watches for PCG modal close + zone cookie
 *  - "delay" → shows after configurable page load delay
 *
 * CAPTCHA strategy:
 *  The form submits NATIVELY (no AJAX, no iframe). Shopify's
 *  CAPTCHA scripts intercept the submit and inject the token.
 *  A hidden return_to field redirects back with ?esp_success=1
 *  so we can detect success and show a confirmation message.
 * ============================================================
 */

(function () {
  'use strict';

  const CONFIG = window.ESP_CONFIG || {
    trigger: 'after_postal_code',
    delay: 3,
    dismissDays: 30,
    buttonText: 'Subscribe',
    successMessage: 'Thanks for subscribing!'
  };

  const COOKIE_DISMISSED = 'esp_dismissed';

  /* ──────────────────────────────────────────────────
   * UTILITIES
   * ────────────────────────────────────────────────── */
  function setCookie(name, val, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + val + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? m[2] : null;
  }

  function isDismissed() {
    return !!getCookie(COOKIE_DISMISSED);
  }

  function dismiss() {
    setCookie(COOKIE_DISMISSED, '1', CONFIG.dismissDays || 30);
  }

  const $ = function (s) { return document.querySelector(s); };

  /* ──────────────────────────────────────────────────
   * SHOW / HIDE
   * ────────────────────────────────────────────────── */
  function show() {
    if (isDismissed()) return;
    var ov = $('#espOverlay');
    var popup = $('#espPopup');
    if (!ov || !popup) return;
    ov.classList.add('is-active');
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    var inp = popup.querySelector('.esp-popup__input');
    if (inp) setTimeout(function () { inp.focus(); }, 350);
  }

  function hide() {
    var ov = $('#espOverlay');
    var popup = $('#espPopup');
    if (!ov || !popup) return;
    ov.classList.remove('is-active');
    popup.classList.remove('is-active');
    document.body.style.overflow = '';
    dismiss();
  }

  /* ──────────────────────────────────────────────────
   * SUCCESS STATE (after redirect back)
   * ────────────────────────────────────────────────── */
  function showSuccessPopup() {
    var popup = $('#espPopup');
    var successEl = $('#espSuccess');
    var ov = $('#espOverlay');
    if (!popup || !successEl || !ov) return;

    // Hide form elements, show only success message
    var content = popup.querySelector('.esp-popup__content');
    if (content) {
      Array.from(content.children).forEach(function (child) {
        if (child !== successEl) child.style.display = 'none';
      });
      successEl.style.display = 'block';
    }

    // Show the popup
    ov.classList.add('is-active');
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    dismiss();

    // Clean the URL parameter
    var url = new URL(window.location);
    url.searchParams.delete('esp_success');
    window.history.replaceState({}, '', url);

    // Auto-close after 3 seconds
    setTimeout(hide, 3000);
  }

  /* ──────────────────────────────────────────────────
   * FORM VALIDATION (client-side only)
   * The form submits natively — Shopify handles CAPTCHA
   * ────────────────────────────────────────────────── */
  function validateForm(e) {
    var form = document.getElementById('esp-form');
    var emailInput = form ? form.querySelector('.esp-popup__input') : null;
    var errorEl = $('#espError');

    if (!form || !emailInput) return;

    var email = emailInput.value.trim();
    if (errorEl) errorEl.textContent = '';
    emailInput.classList.remove('has-error');

    if (!email) {
      e.preventDefault();
      if (errorEl) errorEl.textContent = 'Please enter your email address.';
      emailInput.classList.add('has-error');
      emailInput.focus();
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      e.preventDefault();
      if (errorEl) errorEl.textContent = 'Please enter a valid email address.';
      emailInput.classList.add('has-error');
      emailInput.focus();
      return;
    }

    // Validation passed — let the form submit natively.
    // Shopify's CAPTCHA will intercept, add token, and post.
    // The return_to field will redirect back with ?esp_success=1.
    var btn = $('#espSubmit');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Submitting\u2026';
    }
  }

  /* ──────────────────────────────────────────────────
   * TRIGGER: After Postal Code Gate
   * Watches for pcg_zone cookie + PCG modal closing
   * No modifications to postal-code-gate.js needed.
   * ────────────────────────────────────────────────── */
  function setupPostalCodeTrigger() {
    var pcgModal = document.getElementById('pcgModal');

    // If PCG modal doesn't exist, fall back to delay trigger
    if (!pcgModal) {
      setupDelayTrigger();
      return;
    }

    // If zone cookie already exists (returning visitor), don't show
    if (getCookie('pcg_zone')) return;

    // Watch for PCG modal to close (class 'is-active' removed)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function () {
        var modalClosed = !pcgModal.classList.contains('is-active');
        var hasZone = !!getCookie('pcg_zone');

        if (modalClosed && hasZone) {
          observer.disconnect();
          // Delay so PCG overlay finishes animating out
          setTimeout(show, 500);
        }
      });
    });

    observer.observe(pcgModal, { attributes: true, attributeFilter: ['class'] });
  }

  /* ──────────────────────────────────────────────────
   * TRIGGER: Delay
   * ────────────────────────────────────────────────── */
  function setupDelayTrigger() {
    setTimeout(show, (CONFIG.delay || 3) * 1000);
  }

  /* ──────────────────────────────────────────────────
   * BIND EVENTS
   * ────────────────────────────────────────────────── */
  function bindEvents() {
    var closeBtn = $('#espClose');
    if (closeBtn) {
      closeBtn.addEventListener('click', hide);
    }

    // Validate on form submit — if valid, let it submit natively
    var form = document.getElementById('esp-form');
    if (form) {
      form.addEventListener('submit', validateForm);
    }

    // Close on overlay click
    var ov = $('#espOverlay');
    if (ov) {
      ov.addEventListener('click', hide);
    }

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var popup = $('#espPopup');
        if (popup && popup.classList.contains('is-active')) {
          hide();
        }
      }
    });
  }

  /* ──────────────────────────────────────────────────
   * INIT
   * ────────────────────────────────────────────────── */
  function init() {
    // Check if we're returning from a successful signup
    var params = new URLSearchParams(window.location.search);
    if (params.get('esp_success') === '1') {
      showSuccessPopup();
      return;
    }

    if (isDismissed()) return;

    bindEvents();

    if (CONFIG.trigger === 'after_postal_code') {
      setupPostalCodeTrigger();
    } else if (CONFIG.trigger === 'delay') {
      setupDelayTrigger();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for theme editor testing
  window.ESP = { show: show, hide: hide };
})();